import { render, staticRenderFns } from "./profit-margin.vue?vue&type=template&id=0dbadf5c&scoped=true"
import script from "./profit-margin.vue?vue&type=script&lang=js"
export * from "./profit-margin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbadf5c",
  null
  
)

export default component.exports